import { render, staticRenderFns } from "./ThirdpartyCardGroup.vue?vue&type=template&id=036e62bd&"
import script from "./ThirdpartyCardGroup.vue?vue&type=script&lang=js&"
export * from "./ThirdpartyCardGroup.vue?vue&type=script&lang=js&"
import style0 from "./ThirdpartyCardGroup.vue?vue&type=style&index=0&id=036e62bd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports